import * as React from 'react'
export const Mw = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 342" width="1em" height="1em" {...props}>
    <path fill="#272727" d="M0 0h512v114H0z" />
    <path fill="#e40112" d="M0 114h512v114H0z" />
    <path fill="#07893f" d="M0 228h512v114H0z" />
    <circle cx={256} cy={125} r={95} fill="#e40112" />
  </svg>
)
